import { utilities } from "utils/utilities";
import { Node, NodeDto } from "../nodes/Node"

export interface WorkflowDto {
  id: string;
  name?: string;
  description?: string;
  workflowLink?: string;
  isActive?: boolean;
  nodes: NodeDto[];
}

export class Workflow {
    id: string;
    name: string | undefined;
    description: string | undefined;
    workflowLink: string | undefined;
    isActive: boolean | undefined;
    nodes!: Node[];

    constructor(isActive: boolean, id?: string, name? :string, description?: string, workflowLink?: string){
        this.id = id ? id : utilities.DEFAULT_GUID;
        this.isActive = isActive;
        this.name = name;
        this.description = description;
        this.workflowLink = workflowLink;
    }

    getWorkflowLink(artistId: string): string {
        return `${process.env.REACT_APP_API_BASE_URL}artists/${artistId}/workflows/${this.id}`;
    }

    toDto(artistId?: string): WorkflowDto {
      const nodesDto: NodeDto[] = (this.nodes || []).map(n => {
        // If n is a Node instance with toDto, use it
        if (n && typeof (n as Node).toDto === "function") {
          return (n as Node).toDto();
        }

        // Otherwise treat n as a plain object / DTO-like and create a Node instance
        // We normalize fields to the NodeDto shape then use Node.fromDto so that
        // any Node initialization logic is honored.
        const plain: any = n || {};
        const dtoLike: Partial<NodeDto> & { enrollment?: any } = {
          nodeId: plain.id ?? plain.nodeId,
          position: plain.position,
          index: plain.index,
          nextNodeId: plain.nextNode?.id ?? plain.nextNodeId,
          enrollmentDto:
            plain.enrollment && typeof plain.enrollment.toDto === "function"
              ? plain.enrollment.toDto()
              : plain.enrollment,
        };

        const nodeInstance = Node.fromDto(dtoLike);
        return nodeInstance.toDto();
      });

      return {
        id: this.id,
        name: this.name,
        description: this.description,
        workflowLink: artistId ? this.getWorkflowLink(artistId) : this.workflowLink,
        isActive: this.isActive,
        nodes: nodesDto
      };
    }

}